/**
 * Created by slava on 9/8/17
 */

const LineBoosterView = FieldBoosterView.extend({
    onHurtCellsAnimation: function (cells) {
        const fieldView = Game.currentGame.field.onGetView();

        const start = cells[0];
        const startP = BaseCellView.alignInTheGrid(start.x, start.y);

        const animation = new cleverapps.Spine(bundles.game.jsons.linebooster_spine_json);
        animation.setLocalZOrder(100);
        fieldView.addChild(animation);

        const styles = cleverapps.styles.LineBoosterView;
        animation.setPosition(startP.x, startP.y + styles.animation.y);

        animation.setAnimation(0, "animation", false);
        animation.setTimeScale(styles.timeScale.scale);
        animation.setCompleteListener(() => {
            animation.runAction(new cc.Sequence(
                new cc.CallFunc(() => {
                    if (Game.currentGame) {
                        Game.currentGame.bigExplode();
                    }
                }),
                new cc.RemoveSelf()
            ));
        });

        cleverapps.effects.fire("match3.booster.rolling_pin.use");
    }
});

cleverapps.styles.LineBoosterView = {
    animation: {
        y: -450
    },

    timeScale: {
        scale: 1.4
    }
};